/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const userSetup = async (data: any = undefined): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;

  if (data) {
    try {
      const res = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.userSetup}/${companyId}`,
        data: data ?? {},
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {}
      });

      return res.data;
    } catch (err) {
      return await Promise.reject(err);
    }
  }
};

export default userSetup;
